module.exports = __webpack_public_path__ + "static/media/longue.b3c5431c.png";